<div class="modal__header">
	<h2 class="title" id="modal__title">
		<!-- Your data will be lost -->
		{{ 'modals.discard.text.yourDataWillBeLost' | ibeadmin: 'sync' }}
	</h2>
	<div class="modal__header-actions">
		<button aria-label="Close dialog" (click)="closeModal()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
		</button>
	</div>
</div>
<div class="modal__body sl--scrollable">
	<!-- If you close this window, the data you entered will be lost. -->
	{{ 'modals.discard.text.ifYouCloseThisWindow' | ibeadmin: 'sync' }}
</div>
<div class="modal__footer">
	<div class="modal__footer-action positive-action">
		<button (click)="cancel()" class="button button--small button-accent">
			<!-- Continue Editing -->
			{{ 'modals.discard.text.continueEditing' | ibeadmin: 'sync' }}
		</button>
	</div>
	<div class="modal__footer-action negative-action">
		<button class="button button--small" (click)="discard()">
			<!-- Discard data -->
			{{ 'modals.discard.text.discardData' | ibeadmin: 'sync' }}
		</button>
	</div>
</div>
